// extracted by mini-css-extract-plugin
export default {"form":"_2hlzqff6tGO7-L3po6W-Vr","label":"_3JZS04FKWwV-E9kHGrMOt5","input":"_33Ij3w3UaIiglNMYpTk8DB","errorMessage":"wfRidGCkaY4DKFfgWtaBE","required":"_26kfl1nwTJTgduAO5U3MXj"};